import getApi from '../../../api/apisauceConfig'
import type {TrustedSource, TrustedSourceCreatePayload} from "../../../model/TrustedSource";

export const postTrustedSource = (payload: TrustedSourceCreatePayload) =>
  getApi().post<TrustedSource>('/trusted_sources', payload)
